import React, { useState } from 'react';
import {
  addHighlightedSkillAPI,
  addSelfReportedSkillAPI,
  skillsSearchAPI,
  getUserId,
  GLOBAL_COLORS,
} from '../../../hooks';
import './AddSkillModal.css';
import { LiaTimesSolid } from 'react-icons/lia';

export const AddSkillModal = (props) => {
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [searchedSkills, setSearchedSkills] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setSearchTerm(inputValue);

    if (inputValue.trim() === '' || inputValue.length < 4) {
      setSearchedSkills([]);
      return;
    }

    const delay = 400;
    setTimeout(() => {
      skillsSearchAPI(inputValue, (data) => {
        setSearchedSkills(data);
      });
    }, delay);
  };

  const formatSelfReportedSkillData = () => {
    const skillList = props.skillsData.map((skill) => ({
      name: skill.name,
      starCount: skill.starCount,
    }));

    skillList.push(
      ...selectedSkills.map((skill) => ({
        name: skill._source.name,
        starCount: 1,
      }))
    );

    return {
      user_id: getUserId(),
      skills: skillList.map((skill) => skill.name),
      data: {
        level: skillList.map((skill) => skill.starCount),
      },
    };
  };

  const formatHighlightedSkillData = () => {
    const skillList = props.skillsData.map((skill) => skill.name);
    skillList.push(...selectedSkills.map((skill) => skill._source.name));

    return {
      user_id: getUserId(),
      skills: skillList,
    };
  };

  const handleAddSkillBtn = () => {
    if (props.skillType === 'selfReported') {
      addSelfReportedSkillAPI(formatSelfReportedSkillData(), function (data) {
        window.location.reload();
        // if (data.status_code === 200) {
        //   // props.refreshSkills(data);
        //   // TODO : remove the need to manually reload this
        //   window.location.reload();
        // } else {
        //   // todo : we need custom alert boxes here
        //   alert('Something went wrong');
        // }
        handleCloseModal();
      });
    }

    if (props.skillType === 'highlighted') {
      addHighlightedSkillAPI(formatHighlightedSkillData(), function (data) {
        window.location.reload();
        // if (data.status_code === 200) {
        //   props.refreshSkills(data?.body?.skills);
        // } else {
        //   alert('Something went wrong');
        // }

        handleCloseModal();
      });
    }
  };

  const handleSkillSelect = (skill) => {
    return () => {
      const skillIndex = selectedSkills.findIndex(
        (selectedSkill) => selectedSkill._id === skill._id
      );
      if (skillIndex === -1) {
        setSelectedSkills([...selectedSkills, skill]);
      } else {
        const newSelectedSkills = [...selectedSkills];
        newSelectedSkills.splice(skillIndex, 1);
        setSelectedSkills(newSelectedSkills);
      }
    };
  };

  const handleCloseModal = () => {
    setSearchedSkills([]);
    setSelectedSkills([]);
    setSearchTerm('');
    props.closeModal();
  };
  return (
    <div className="popup_div active">
      <div className="popup_cont sk">
        <div className="add_skill_popup active">
          <div className="div-block-520">
            <div>Add Skill</div>
            <LiaTimesSolid
              color={GLOBAL_COLORS.icon_color}
              className={'cancel_add_skill'}
              style={{
                height: '16px',
                width: '16px',
              }}
              onClick={handleCloseModal}
            />
            {/*<img
              src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacfc_close.png"
              loading="lazy"
              alt=""
              onClick={handleCloseModal}
              className="cancel_add_skill"
            />*/}
          </div>
          <div className="div-block-525">
            <div className="div-block-469 sk_s">
              <div className="form-block-15 s_skill w-form">
                <form
                  id="email-form"
                  name="email-form"
                  data-name="Email Form"
                  method="get"
                  className="form-10"
                  data-wf-page-id="6596f6f119932dba27256924"
                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb8371da"
                  aria-label="Email Form"
                >
                  <div className="div-block-410">
                    <img
                      src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacc8_magnifying-glass.png"
                      loading="lazy"
                      alt=""
                      className="image-164"
                    />
                  </div>
                  <input
                    className="text-field-14 n_text w-input"
                    name="searchSkills"
                    data-name="searchSkills"
                    placeholder="Search for skills"
                    type="email"
                    id="searchSkills"
                    value={searchTerm}
                    onChange={handleInputChange}
                    required
                  />
                </form>
                {selectedSkills.length > 0 && (
                  <div id="sk_selected" className="text-block-371">
                    Selected
                  </div>
                )}

                <div className="skill_search_selected active">
                  {selectedSkills?.map((skill) => (
                    <div key={skill._id} className="skill_blog">
                      <div className="skill_bg">
                        <img
                          src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacbd_skills_icon.png"
                          loading="lazy"
                          alt=""
                          className="image-220"
                        />
                      </div>
                      <div>{skill._source.name}</div>
                    </div>
                  ))}
                </div>

                <div className="skill_search_results">
                  {searchedSkills?.map((skill) => (
                    <div
                      className="skill_blog"
                      key={skill._id}
                      onClick={handleSkillSelect(skill)}
                    >
                      <div className="skill_bg">
                        <img
                          src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacbd_skills_icon.png"
                          loading="lazy"
                          alt=""
                          className="image-220"
                        />
                      </div>
                      <div>{skill._source.name}</div>
                    </div>
                  ))}
                </div>
                <div
                  className="w-form-done"
                  tabIndex={-1}
                  role="region"
                  aria-label="Email Form success"
                >
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div
                  className="w-form-fail"
                  tabIndex={-1}
                  role="region"
                  aria-label="Email Form failure"
                >
                  <div>
                    Oops! Something went wrong while submitting the form.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="popup-f">
            <div
              className="div-block-475 confirm_add_skill"
              onClick={handleAddSkillBtn}
            >
              <div className="text-block-284 add_skill_text">Add Skill</div>
            </div>
          </div>
        </div>
        <div data-name="followers" className="skill_report_popup">
          <div className="div-block-520">
            <div>Javascript</div>
            <img
              src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacfc_close.png"
              loading="lazy"
              alt=""
              className="cancel_skill_report"
            />
          </div>
          <div className="div-block-525">
            <div className="div-block-469 sk_s">
              <div className="div-block-441">
                <img
                  src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacbd_skills_icon.png"
                  loading="lazy"
                  alt=""
                  className="image-154"
                />
                <div>
                  <div className="text-block-303">Self Rating</div>
                  <div className="text-block-267">Level 3</div>
                  <div className="edit_rating">Edit Rating</div>
                </div>
                <div className="item_options">
                  <div className="item_options_triger">
                    <img
                      src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bac9e_menu.png"
                      loading="lazy"
                      alt=""
                      className="image-182"
                    />
                  </div>
                  <div
                    className="options_div skill_options"
                    style={{ display: 'none' }}
                  >
                    <div className="text-block-238">Clear Rating</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="popup-f">
            <div className="div-block-475 confirm_skill_report">
              <div className="text-block-284 add_skill_text">Save</div>
            </div>
          </div>
        </div>
        <div data-name="followers" className="rate_skill_popup">
          <div className="div-block-520">
            <div>Rate your expertise in "Javascript"</div>
            <img
              src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacfc_close.png"
              loading="lazy"
              alt=""
              className="rate_skill_close"
            />
          </div>
          <div className="div-block-525">
            <div className="div-block-469 sk_s">
              <div className="rate_skill r_popup">
                <div className="rate_skill_block">
                  <div className="div-block-500">
                    <div className="step_n">1</div>
                    <div className="step_n">2</div>
                    <div className="step_n">3</div>
                    <div className="step_n">4</div>
                    <div className="step_n">5</div>
                    <div className="step_n">6</div>
                    <div className="step_n">7</div>
                    <div className="step_n">8</div>
                    <div className="step_n">9</div>
                    <div className="step_n">10</div>
                  </div>
                  <div className="fs-rangeslider_form w-form">
                    <form
                      id="email-form"
                      name="email-form"
                      data-name="Email Form"
                      method="get"
                      data-wf-page-id="6596f6f119932dba27256924"
                      data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb837221"
                      aria-label="Email Form"
                    >
                      <div
                        fs-rangeslider-formatdisplay="true"
                        fs-rangeslider-element="wrapper"
                        fs-rangeslider-min={0}
                        fs-rangeslider-max={90}
                        fs-rangeslider-step={10}
                        className="fs-rangeslider_wrapper"
                      >
                        <div
                          fs-rangeslider-element="track"
                          className="fs-rangeslider_track"
                          style={{ position: 'relative' }}
                        >
                          <div
                            fs-rangeslider-element="handle"
                            className="fs-rangeslider_handle is-pink"
                            role="slider"
                            tabIndex={0}
                            aria-label="From-3"
                            aria-valuenow={0}
                            aria-valuemin={0}
                            aria-valuemax={90}
                            style={{
                              position: 'absolute',
                              right: 'unset',
                              top: '50%',
                              transform: 'translate(-50%, -50%)',
                              left: 0,
                            }}
                          >
                            <div className="fs-rangeslider_handle-value" />
                          </div>
                          <div
                            fs-rangeslider-element="fill"
                            className="fs-rangeslider_fill"
                            style={{
                              position: 'absolute',
                              right: 'unset',
                              left: 0,
                              width: 0,
                            }}
                          />
                        </div>
                        <input
                          className="fs-rangeslider_input w-input"
                          maxLength={256}
                          name="From-3"
                          fs-cmsfilter-field="price"
                          data-name="From 3"
                          fs-cmsfilter-range="from"
                          placeholder="From"
                          type="text"
                          id="From-3"
                        />
                        <div className="fs-range_values hidden" />
                      </div>
                    </form>
                    <div
                      className="w-form-done"
                      tabIndex={-1}
                      role="region"
                      aria-label="Email Form success"
                    >
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div
                      className="w-form-fail"
                      tabIndex={-1}
                      role="region"
                      aria-label="Email Form failure"
                    >
                      <div>
                        Oops! Something went wrong while submitting the form.
                      </div>
                    </div>
                  </div>
                  <div className="div-block-468">
                    <div className="text-block-259">Beginner</div>
                    <div className="text-block-259 mgl">Expert</div>
                  </div>
                  <div className="div-block-416">
                    <div className="rate_level">
                      <div className="html-embed-10 rate_level w-embed">
                        <style
                          dangerouslySetInnerHTML={{
                            __html:
                              '\n\n\n\n/*** <--- CIRCLE STYLES ---> ***/\n.wrap-circles {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.circle {\n  position: relative;\n  width: 74px;\n  height: 74px;\n  border-radius: 50%;\n  overflow: hidden;\n}\n.circle.per-25 {\n  background-image: conic-gradient(#369 33%, #def 0);\n}\n\n.circle .inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 60px;\n  height: 60px;\n  background: #fff;\n  border-radius: 50%;\n  font-size: 32px;\n  font-weight: 300;\n  color: #528ac1;\n}\n  ',
                          }}
                        />
                        <div
                          className="circle per-25"
                          style={{
                            backgroundImage:
                              'conic-gradient(#528ac1 30%, #def 0)',
                          }}
                        >
                          <div className="inner">
                            <span>3</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-block-263">
                      Can complete narrow and limited tasks requiring basic
                      skills with direct supervision or guidance.
                    </div>
                    <div className="div-block-503" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="popup-f rate">
            <div className="div-block-475 cancel_skill_rate">
              <div className="text-block-284 add_skill_text cancel">Cancel</div>
            </div>
            <div className="div-block-475 delete-skills">
              <div className="text-block-284 add_skill_text cancel delete-s">
                Delete skill
              </div>
            </div>
            <div className="div-block-475 confirm_skill_rate">
              <div className="text-block-284 add_skill_text">Confirm</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
